import React, { Component } from 'react';
import styled, { createGlobalStyle, keyframes } from 'styled-components';
import { connect } from 'react-redux';
import LoadingComponent from '../../components/common/LoadingComponent';
import NewBenefitsCard from '../../components/policy/newBenefitsCard';
import { BoldText, Text, SemiBoldText } from '../../components/common/Text';
import NewClaimsCard from '../../components/policy/NewClaimsCard';
import NewHelpCard from '../../components/policy/NewHelpCard';
import Header from '../../components/common/Header';
import {
  InsureTabApi,
  InsureTabOpdBenefits,
  getContactMatrix,
  getFaqData,
} from '../../services';
import { Carousel } from 'react-responsive-carousel';
import arrowLeft from '../../images/common/arrow-left.svg';
import Tappable from 'react-tappable/lib/Tappable';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import EyeIcon from '../../images/newInsurerPage/eyeIcon.svg';
import FaqQuestionMark from '../../images/newInsurerPage/FaqQuestionMark.svg';
import QaCross from '../../images/newInsurerPage/QaModalcross.svg';
import WalletCardBackground1 from '../../images/newInsurerPage/walletBackground1.svg';
import WalletCardBackground2 from '../../images/newInsurerPage/walletBackground2.svg';
import WalletCardBackground3 from '../../images/newInsurerPage/walletBackground3.svg';
import DownArrow from '../../images/newInsurerPage/faqArrow.svg';
import QsArrow from '../../images/newInsurerPage/ContactSupportModalArrow.svg';
import PurpleDownArrow from '../../images/policy/purpleArrowDown.svg';
import BlueDownArrow from '../../images/policy/blueArrowDown.svg';
import GreenDownArrow from '../../images/policy/greenArrowDown.svg';
import NewHealthBenefitsCard from '../../components/policy/NewHealthBenefitsCard';
import Modal from '../../containers/common/Modal';
import { FadeInTransition } from '../../components/transitions/transitions';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  height: 100svh;
  background: #ffffff;
  overflow: hidden;
  @media (min-width: 768px) {
    height: 90vh;
  }
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  background: white;
`;

const Body = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: stretch;
  padding-bottom: 2rem;
  overflow-x: hidden;
`;
const QaContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  height: 100svh;
  width: 100vw;
`;

const HeaderContainer = styled.div`
  // z-index: 9999;
  // position: fixed;
  // top: 0px;
  // left: 0px;
  // width: 100%;
  // display: flex;
  // flex-direction: column;
  // padding: 22px 0 18px;
  // align-self: stretch;
  // align-items: center;
  // justify-content: center;
  // border-bottom: 1px solid #f0f3f6;
  // background-color: white;

  display: flex;
  //flex-direction: column;
  padding: 30px 0 18px;
  align-self: stretch;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f3f6;
`;

// const Header = styled.div`
//   display: flex;
//   width: 100%;
//   align-items: center;
//   justify-content: space-between;
//   padding-left: 0.5rem;
//   padding-right: 1.1rem;
// `;

const HeaderText = styled(BoldText)`
  font-size: 16px;
  text-align: center;

  font-weight: 600;
`;
const SectionHeading = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 1rem;
`;
const Session = styled.div`
  width: 90%;
  margin: auto;
  //margin-top: 1rem;
  //margin-bottom: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e6e9ec;
`;
const BackContainer = styled(Tappable)`
  //   margin-right: 0.5rem;

  display: flex;
  width: 44px;
  align-items: center;
  justify-content: center;
  &.Tappable-active {
    opacity: 0.2;
  }
`;
const QuestionButton = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;
const HeaderTitleContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;
const FlexDiv = styled.div`
  display: flex;
  align-items: center;
`;

const styledElement = document.getElementsByClassName('carousel-root');

class QaPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      insured: false,
      opdPolicies: [],
      ipdPolicies: [],
      claims: [],
      opdWalletDetails: [],
      policyDetails: {},
      policySavings: {},
      reimbursementRequests: null,
      coiUrl: null,
      activeTabIndex: 0,
      activeTab: '',
      opdDependentWallet: [],
      dependentSelectedWallet: {},
      opdEcards: [],
      benefitsSection: [],
      claimsSection: [],
      helpSection: [],
      offersSection: [],
      walletSection: [],
      currentOpenCard: null,
      healthBenefits: [],
      cards: [],
      policyDocumentLink: null,
      faqData: [],
      currentFaqOpen: null,
      showHospitalizationModal: false,
      showPendingHospilationBlocker: true,
      contactData: [],
      currentContactDataIndex: null,
      isArrowRotated: false,
      rotatedArrows: [],
      supportModalArrows: [],
      openedContainers: [],
      supportCardOpened: null,
    };
  }

  // Header() {
  //   return (
  //     <HeaderContainer>
  //       <Header>
  //         <FlexDiv>
  //           <BackContainer onTap={() => this.props.history.goBack()}>
  //             <img src={arrowLeft} alt="back" />{' '}
  //           </BackContainer>
  //           <HeaderText>Facing the following issues?</HeaderText>
  //         </FlexDiv>
  //         <QuestionButton
  //           onTap={() => this.setState({ showHospitalizationModal: true })}
  //         >
  //           <img src={FaqQuestionMark} alt="" />
  //         </QuestionButton>
  //       </Header>
  //     </HeaderContainer>
  //   );
  // }
  //   {
  //     <HeaderContainer>
  //             <BackContainer onTap={() => history.push('/home')}>
  //               <img src={arrowLeft} alt="back" />
  //             </BackContainer>
  //             <HeaderTitleContainer>
  //               <HeaderText>Clinic Consultation </HeaderText>
  //             </HeaderTitleContainer>
  //           </HeaderContainer>
  //   }
  getAppropriateRoute(key) {
    //console.log('function is accessed', key);
    switch (key) {
      case 'labs':
        return this.props.history.push('/lab-test');
      case 'pharmacy':
        return this.props.history.push('/pharmacy');
      default:
        return '';
    }
  }

  getBackground(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return WalletCardBackground1;
      case 1:
        return WalletCardBackground2;
      case 2:
        return WalletCardBackground3;
      default:
        return '';
    }
  }
  getBackgroundColor(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;

    switch (backgroundIndex) {
      case 0:
        return 'linear-gradient(132deg, rgba(249, 126, 124, 0.20) 0%, rgba(255, 109, 162, 0.10) 95.83%)';
      case 1:
        return 'linear-gradient(136deg, #C7EBFF 0%, rgba(211, 237, 255, 0.56) 91.69%)';
      case 2:
        return 'linear-gradient(151deg, rgba(146, 220, 70, 0.20) 0.01%, rgba(232, 228, 110, 0.20) 100%)';
      default:
        return '';
    }
  }
  getArrow(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return PurpleDownArrow;
      case 1:
        return BlueDownArrow;
      case 2:
        return GreenDownArrow;
      default:
        return '';
    }
  }
  getTextColor(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return '#E16262';
      case 1:
        return '#2E89BD';
      case 2:
        return '#90B529';
      default:
        return '';
    }
  }
  hideModal = () => {
    this.setState({
      showRelativeModal: false,
      showHospitalizationModal: false,
      currentContactDataIndex: null,
    });
  };
  onCardTap(index) {
    if (this.state.currentOpenCard === index) {
      this.setState({ currentOpenCard: null });
    } else {
      this.setState({ currentOpenCard: index });
    }
  }
  handleOnTap(key, data) {
    switch (key) {
      case 'phone':
        return (window.location.href = `tel:${data}`);
      case 'email':
        return (window.location.href = `mailto:${data}`);
      case 'chat':
        return (window.location.href = `sms:${data}`);
      default:
        return null;
    }
  }
  onSupportCardTap(index) {
    if (this.state.supportCardOpened === index) {
      this.setState({ supportCardOpened: null });
    } else {
      this.setState({ supportCardOpened: index });
    }
    // let newSupportModalArrows = [...this.state.supportModalArrows];
    // newSupportModalArrows[index] = !newSupportModalArrows[index];

    // if (this.state.currentContactDataIndex === index) {
    //   this.setState({ supportModalArrows: newSupportModalArrows });
    //   this.setState({ currentContactDataIndex: null });
    // } else {
    //   this.setState({ supportModalArrows: newSupportModalArrows });
    //   this.setState({ currentContactDataIndex: index });
    // }
  }
  // setCurrentFaq(index) {
  //   let newRotatedArrows = [...this.state.rotatedArrows];
  //   newRotatedArrows[index] = !newRotatedArrows[index];

  //   if (index === this.state.currentFaqOpen) {
  //     this.setState({ rotatedArrows: newRotatedArrows });
  //     this.setState({ currentFaqOpen: null });
  //   } else {
  //     this.setState({ rotatedArrows: newRotatedArrows });
  //     this.setState({ currentFaqOpen: index });
  //   }
  // }
  setOpenedContainers(index) {
    let newOpenedContainers = [...this.state.openedContainers];
    if (newOpenedContainers[index] === true) {
      newOpenedContainers[index] = false;
    } else {
      newOpenedContainers[index] = true;
    }
    // newOpenedContainers[index] = [!newOpenedContainers[index]];

    this.setState({ openedContainers: newOpenedContainers });
    //console.log('opened containers', newOpenedContainers);
  }
  renderBody() {
    return (
      <div>
        {this.state &&
          this.state.faqData &&
          this.state.faqData.length > 0 &&
          this.state.faqData.map((item, index) => {
            //console.log('rendering');
            return (
              <Container key={index}>
                <HeadDiv borderBottom={this.state.openedContainers[index]}>
                  <HeadTitle>{item.title}</HeadTitle>
                  <ArrowButton
                    onClick={() => this.setOpenedContainers(index)}
                    className={
                      this.state.openedContainers[index] ? 'rotated' : ''
                    }
                  >
                    <img
                      src={DownArrow}
                      alt="down arrow"

                      //style={{ rotate: '180deg' }}
                    />
                  </ArrowButton>
                </HeadDiv>
                {this.state.openedContainers[index] === true && (
                  <BodyDiv>{item.description}</BodyDiv>
                )}
              </Container>
            );
          })}
        {this.state && this.state.showHospitalizationModal && (
          <Modal>
            <QaContainer
              onClick={() =>
                this.setState({
                  //showHospitalizationModal: false,
                  //currentContactDataIndex: null,
                })
              }
            >
              <FadeInTransition
                in={this.state.showPendingHospilationBlocker}
                timeout={200}
                mountOnEnter
                unmountOnExit
                onExited={this.hideModal}
                appear
              >
                <div
                  ref={(node) => (this.node = node)}
                  className="bg-textbox flex flex-col items-center justify-center rounded-12"
                  style={{ width: '90%', maxWidth: '400px' }}
                >
                  <PopupContainer>
                    <PopupHeader>
                      <PopupTitle>Contact Support</PopupTitle>
                      <PopupClose
                        onTap={() => {
                          this.setState({
                            showHospitalizationModal: false,
                            currentContactDataIndex: null,
                          });
                        }}
                      >
                        <img src={QaCross} alt="" />
                      </PopupClose>
                    </PopupHeader>
                    {this.state.contactData.map((item, index) => {
                      return (
                        <PopupBodyContainer key={index}>
                          <PopupHeaderWrapper
                            borderBottom={
                              this.state.currentContactDataIndex === index
                            }
                            paddingBottom={
                              this.state.currentContactDataIndex === index
                            }
                          >
                            <PopupBodyDetails>
                              <PopupDetailSubtitle>
                                {item.title}
                              </PopupDetailSubtitle>
                              <PopupDetailTitle>
                                {item.subtitle}
                              </PopupDetailTitle>
                            </PopupBodyDetails>
                            <SupportButton
                              onTap={() => this.onSupportCardTap(index)}
                              className={
                                this.state.supportCardOpened === index
                                  ? 'rotated'
                                  : ''
                              }
                            >
                              <img src={QsArrow} alt="" />
                            </SupportButton>
                          </PopupHeaderWrapper>
                          {this.state.supportCardOpened === index &&
                            item.contactOptions.map((inner) => {
                              return (
                                <InnerContainer>
                                  <InnerLeft>
                                    <img src={inner.logo} alt="" />
                                    <InnerLeftNumber>
                                      {inner.infoTitle}
                                    </InnerLeftNumber>
                                  </InnerLeft>
                                  <PhoneAndEmailTappable
                                    onTap={() =>
                                      this.handleOnTap(
                                        inner.action,
                                        inner.infoTitle
                                      )
                                    }
                                  >
                                    <InnerRight>{inner.action}</InnerRight>
                                  </PhoneAndEmailTappable>
                                </InnerContainer>
                              );
                            })}
                        </PopupBodyContainer>
                      );
                    })}
                  </PopupContainer>
                </div>
              </FadeInTransition>
            </QaContainer>
          </Modal>
        )}
      </div>
    );
  }
  fetchData() {
    const { authToken } = this.props;
    //console.log('this props are', this.props);

    getFaqData(authToken)
      .then((response) => {
        this.setState({ faqData: response.faq });
        this.setState({
          rotatedArrows: new Array(this.state.faqData.length).fill(false),
        });
      })
      .catch((err) => console.log('err is', err));

    getContactMatrix(authToken)
      .then((response) => {
        this.setState({ contactData: response.contactCards });

        //console.log('matrix data is ', response.contactCards);
      })
      .catch((err) => console.log('err is', err))
      .finally(() => this.setState({ loading: false }));
  }

  componentDidMount() {
    if (this.props.loginState !== 'LOGGED_IN' || !this.props.authToken) {
      this.props.history.push('/');
    } else {
      this.fetchData();
    }

    //const opdData = this.OpdCardData();

    //console.log('ocards is ', opdData.cards);
    //console.log('wallet data ', opdData.opdUniqueWallets[0].walletDetails);
    //this.setState({ loading: false });
    //console.log('healthbenefits are ', opdData.opdPolicies.healthBenefits);
  }
  render() {
    return !this.state.loading ? (
      <OuterContainer>
        <Header title={'Facing the following issues?'}>
          <QuestionButton
            onTap={() => this.setState({ showHospitalizationModal: true })}
          >
            <img src={FaqQuestionMark} alt="" />
          </QuestionButton>
        </Header>
        <BodyContainer>
          <Body>{this.renderBody()}</Body>
        </BodyContainer>
      </OuterContainer>
    ) : (
      <LoadingComponent />
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
  profileImage: state.user.profileImage,
  sponsorId: state.user.sponsorId,
  showSubscription: state.app.config.showSubscription,
  showOPD: state.app.config.showOPD,
  insured: state.app.config.insured,
  subscribed: state.app.config.subscribed,
});

export default connect(mapStateToProps)(QaPage);

const slideIn = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

const PhoneAndEmailTappable = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;

const PopupClose = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;

const InnerContainer = styled.div`
  padding-top: 1rem;
  padding-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--text-box-card, #e6e9ec);
`;
const InnerLeft = styled.div`
  display: flex;
  align-items: center;
  width: 300px;
`;
const InnerLeftNumber = styled.div`
  padding-left: 5px;
  color: var(--primary-text-new, #0f0b28);
  font-feature-settings: 'clig' off, 'liga' off;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 0%; /* 0px */
`;
const InnerRight = styled.div`
  color: #714fff;
  text-align: right;

  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
`;

const PopupHeaderWrapper = styled.div`
  //border-bottom: 1px solid #e6e9ec;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${(props) => (props.paddingBottom ? '1rem' : '')};
  border-bottom: ${(props) =>
    props.borderBottom ? '1px solid var(--text-box-card, #e6e9ec)' : ''};
  margin-bottom: 1rem;
`;
const SupportButton = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;

const PopupDetailTitle = styled.div`
  color: var(--primary-text-new, #0f0b28);

  font-size: 14px;
  font-weight: 600;
`;
const PopupDetailSubtitle = styled.div`
  color: var(--text-sub, #767787);

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`;

const PopupBodyContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #714fff;
  background: var(--white, #fff);
  padding: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;
const PopupBodyDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const PopupHeader = styled.div`
  padding-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const PopupTitle = styled.div`
  color: var(--primary-text-new, #0f0b28);

  font-size: 14px;
  font-weight: 600;
`;

const PopupContainer = styled.div`
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid var(--text-box-card, #e6e9ec);
  background: var(--white, #fff);
  width: 100%;
`;

const Container = styled.div`
  border-radius: 12px;
  border: 1px solid var(--text-box-card, #e6e9ec);
  background: var(--white, #fff);
  width: 90%;
  margin: auto;
  margin-bottom: 1rem;
`;
const HeadDiv = styled.div`
  display: flex;
  padding: 1rem;
  width: 90%;
  margin: auto;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${(props) =>
    props.borderBottom ? '1px solid var(--text-box-card, #e6e9ec)' : ''};
`;
const HeadTitle = styled.div`
  width: 15rem;
  color: var(--primary-text-new, #0f0b28);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`;
const ArrowButton = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;

const BodyDiv = styled.div`
  color: #000;

  font-size: 12px;
  font-weight: 400;
  padding-top: 0.5rem;
  padding-left: 1rem;
  padding-bottom: 0.5rem;
  padding-right: 1rem;
`;
